import type { SearchColumnDef } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export const getDocumentsColumns = (): SearchColumnDef[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    renderCell: params => formatMoney(params.row.so_luong)
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Mã vị trí',
    width: 120,
    renderCell: params => params.row.ma_vi_tri_data?.ma_vi_tri
  },
  {
    field: 'tk_vt',
    headerName: 'TK kho',
    width: 120,
    renderCell: params => params.row.tk_vt_data?.code
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => params.row.ma_vv_data?.ma_vv
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => params.row.ma_hd_data?.ma_hd
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 150,
    renderCell: params => params.row.ma_dtt_data?.ma_dtt
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 100,
    renderCell: params => params.row.ma_ku_data?.ma_ku
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 100,
    renderCell: params => params.row.ma_phi_data?.ma_phi
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 100,
    renderCell: params => params.row.ma_sp_data?.ma_vt
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 150,
    renderCell: params => params.row.ma_lsx_data?.ma_lsx
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 150,
    renderCell: params => params.row.ma_cp0_data?.ma_cp
  },
  {
    field: 'so_ct_hd4',
    headerName: 'Số hóa đơn mua trong nước',
    width: 150,
    renderCell: params => params.row.hoa_don_data?.so_ct
  },
  {
    field: 'line',
    headerName: 'Dòng HĐ',
    width: 100,
    type: 'number',
    renderCell: params => params.row.line_hd?.line
  }
];
